// ロールID
export const ROLE_ID_MAP = {
    systemManager: 1,
    callcenter: 2,
    inspectionManager: 3,
    inspector: 4,
    GSSManager: 5,
    salesManager: 6,
    newCallcenter: 7
};

// 役職ID
export const POSITION_ID_MAP = {
    sales: 1,
    cs: 2,
    gss: 3,
    ntt: 4,
    branchMgr: 5,
    blockMgr: 6,
    gssMgr: 7,
    salesStrategy: 8,
    salesChief: 9,
    marketing: 10,
    deviceSafetyCenter: 11,
    soc: 12,
    it: 13,
};



// WEBPACK FOOTER //
// ./src/utils/user.js